import { faThumbtack } from '@fortawesome/pro-solid-svg-icons';
import styled from 'styled-components';

import { IconButton } from 'atoms/buttons/IconButton';
import { FontAwesomeIcon } from 'atoms/icons';
import { laptopAndAbove } from 'style/mediaQuery';

const StyledPinButton = styled(IconButton)`
  transform: rotate(45deg);
  align-self: center;
  @media ${laptopAndAbove} {
    align-self: flex-start;
  }
`;

type Props = {
  onClick: () => void;
  isPinned: boolean;
};

export const PinButton = ({ onClick, isPinned }: Props) => (
  <StyledPinButton
    size="compact"
    onClick={onClick}
    color={isPinned ? 'secondary' : 'quaternary'}
  >
    <FontAwesomeIcon icon={faThumbtack} size="xs" />
  </StyledPinButton>
);
